module.exports = __webpack_public_path__ + "static/media/AdobeSign_Step2_Image27.ece99dc1.webp";